import axios from 'axios';

import { type RecordingBulkPatchItem } from '../components/classroom/types';
import { RECORDING_PATCH_BULK } from '../config/apiPaths';
import { getUserUuidHeaders } from '../utils/httpUtils';
import { processApiPath } from '../utils/url';

export type BatchUpdateRecordingsData = {
    userUuid: string;
    classUuid: string;
    recordings: RecordingBulkPatchItem[];
};

export const batchUpdateRecordings = async (data: BatchUpdateRecordingsData) => {
    const url = processApiPath(RECORDING_PATCH_BULK);

    const { userUuid, ...rest } = data;

    return axios.patch(url, rest, {
        headers: {
            'Content-Type': 'application/json',
            ...getUserUuidHeaders(userUuid)
        }
    });
};
